// src/Lexprompt/firebaseConfig.js

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  doc,
  getDoc,
  getDocs,
  setDoc,
  onSnapshot,
  query,
  orderBy,
  where,
  deleteDoc,
  limit,
  startAfter,
} from "firebase/firestore";
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// ─── REPLACE THESE WITH YOUR ACTUAL Lexprompt CONFIG VALUES ───
const firebaseConfig = {
  apiKey: "YOUR_API_KEY",
  authDomain: "PROJECT_ID.firebaseapp.com",
  projectId: "PROJECT_ID",
  storageBucket: "PROJECT_ID.appspot.com",
  messagingSenderId: "SENDER_ID",
  appId: "APP_ID",
};

// ─── Step 1: initialize (or re‐use) a NAMED app “LexPromptApp” ───
const LexPromptApp = !getApps().find((a) => a.name === "LexPromptApp")
  ? initializeApp(firebaseConfig, "LexPromptApp")
  : getApp("LexPromptApp");

// ─── Now get Firestore, Storage, Auth from THAT named app ───
const db = getFirestore(LexPromptApp);
const storage = getStorage(LexPromptApp);
const auth = getAuth(LexPromptApp);
const googleProvider = new GoogleAuthProvider();

// ─── EXPORT EVERYTHING (Firestore, Storage, Auth, helpers) ───
export {
  // Firestore instance + helpers
  db,
  collection,
  addDoc,
  doc,
  getDoc,
  getDocs,
  setDoc,
  onSnapshot,
  query,
  orderBy,
  where,
  deleteDoc,
  limit,
  startAfter,

  // Storage instance + helpers
  storage,
  storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,

  // Auth instance + provider
  auth,
  googleProvider,
};
